import { Link, matchPath, useLocation } from "react-router-dom";
import "../assets/css/Footer.css";

const BrandMark = () => (
    <svg viewBox="0 0 38 38" aria-hidden="true" focusable="false">
        <circle cx="19" cy="19" r="12.5" fill="none" stroke="currentColor" strokeWidth="3" />
        <circle cx="19" cy="19" r="6" fill="none" stroke="currentColor" strokeWidth="3" />
        <circle cx="19" cy="19" r="2.5" fill="currentColor" />
    </svg>
);

const Footer = () => {
    const location = useLocation();
    const isScoreboard = matchPath('/scoreboard/:type/:id', location.pathname);

    if (isScoreboard) return null;

    return (
        <footer className="club-site-footer d-print-none">
            <div className="container-xl club-site-footer-inner">
                <div className="club-site-footer-brand-group">
                    <Link to="/" className="club-site-footer-brand" aria-label="CueClub Manager home">
                        <span className="club-site-footer-mark"><BrandMark /></span>
                        <span className="club-site-footer-brand-copy">
                            <strong>CueClub Manager</strong>
                            <small>Club operations</small>
                        </span>
                    </Link>

                    <p>Tables, matches, queues and screens—kept in sync.</p>
                </div>

                <div className="club-site-footer-meta">
                    <nav className="club-site-footer-legal" aria-label="Legal information">
                        <ul>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/general-conditions">General Conditions</Link></li>
                        </ul>
                    </nav>

                    <p className="club-site-footer-copyright">
                        &copy; {new Date().getFullYear()} CueClub Manager
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
